/* lua.js generated code 0.3.0 */

CommonAnimation = {}
CommonAnimation.createStarGlowAnimation = function () {
    let glow = cc.CSLoader.createNode("cocos/mark_panel_starglow.csb")
    let sprite1 = glow.getChildByName("glow1")
    sprite1.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, 50)))
    let sprite2 = glow.getChildByName("glow2")
    sprite2.runAction(cc.RepeatForever.create(cc.RotateBy.create(1, -50)))
    let sprite3 = glow.getChildByName("glow3")
    sprite3.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(25 / 30, 80 / 96), cc.ScaleBy.create(25 / 30, 96 / 80))))
    let sprite4 = glow.getChildByName("glow4")
    sprite4.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.ScaleBy.create(20 / 30, 96 / 80), cc.DelayTime.create(58 / 30), cc.ScaleBy.create(23 / 30, 80 / 96))))
    let nextAngle = math.random() * 160 + 10
    function genNewStar(star) {
        star.stopAllActions()
        star.setOpacity(255)
        star.setPosition(cc.p(0, 0))
        star.runAction(cc.Sequence.create(cc.Spawn.create(cc.RotateBy.create(1.6, math.random() * 40 + 20), cc.FadeOut.create(1.6), cc.MoveTo.create(1.6, cc.p(Math.cos(nextAngle * Math.PI / 180) * 75, Math.sin(nextAngle * Math.PI / 180) * 75))), cc.CallFunc.create(function () {
            genNewStar(star)
        })))
        nextAngle = nextAngle + math.random() * 160 + 10
    }
    for (let i = 1; i <= 18; i += 1) {
        let star = glow.getChildByName("star" + tostring(i))
        star.setPosition(cc.p(0, 0))
        if (star) {
            star.runAction(cc.Sequence.create(cc.DelayTime.create(1.6 / 18 * (i - 1)), cc.CallFunc.create(function () {
                genNewStar(star)
            })))
        } else {
            break
        }
    }
    return glow
}
